import { render, staticRenderFns } from "./GetLink.vue?vue&type=template&id=4fc8dcc0&scoped=true&"
import script from "./GetLink.vue?vue&type=script&lang=ts&"
export * from "./GetLink.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fc8dcc0",
  null
  
)

export default component.exports